import React from "react";

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {React.ReactNode} [props.actions]
 * @param {React.ReactNode} [props.breadcrumbs]
 * @param {string} [props.testId]
 */
export function GsdPageHeader({ title, subtitle, actions, breadcrumbs, testId = "gsd-page-header" }) {
  return (
    <header className="gsd-page-header" data-testid={testId}>
      {breadcrumbs}
      <div className="gsd-page-header__row">
        <div>
          <h1 className="gsd-page-header__title">{title}</h1>
          {subtitle ? <p className="gsd-page-header__subtitle">{subtitle}</p> : null}
        </div>
        {actions ? <div className="gsd-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {React.ReactNode} [props.actions]
 * @param {string} [props.testId]
 */
export function GsdSectionHeader({ title, subtitle, actions, testId = "gsd-section-header" }) {
  return (
    <div className="gsd-section-header" data-testid={testId}>
      <div>
        <h2 className="gsd-section-header__title">{title}</h2>
        {subtitle ? <p className="gsd-section-header__subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="gsd-section-header__actions">{actions}</div> : null}
    </div>
  );
}
